import React, { useEffect, useState } from 'react';
import { useLoaderData } from "react-router-dom";
import PropTypes from "prop-types";

import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from 'pages/checkout/CheckoutForm';
import { stripe } from 'config';

const stripePromise = Stripe(stripe.publicKey);

export default function PaymentElements({ cartState, handleRequest }) {
  const state = useLoaderData();
  const { cart, user, tax } = state;
  const userId = user.data.id;
  const [clientSecretKey, setClientSecret] = useState(null);
  const [message, setErrorMessage] = useState('');
  const [applePayAvailable, setApplePayAvailable] = useState(false);

  const handleError = (error) => {
    setErrorMessage(error.message);
  };

  const fetchCustomerSession = async () => {
    try {
      const { clientSecret } = await cart.fetchCustomerSession(userId);
      setClientSecret(clientSecret);
    } catch (error) {
      handleError({ message: error.statusText });
    }
  };

  const verifyApplePayAvailable = () => {
    try {
      setApplePayAvailable(
        window.ApplePaySession && window.ApplePaySession.canMakePayments()
      );
    } catch (e) {
      setApplePayAvailable(false);
    }
  };

  // This is a temporal amount to initialize Elements,
  // final amount is calculated from server.
  const tempAmount = () => cart.total() === 0 ? 50 : (cart.total() + tax.amount) * 100;

  const options = {
    mode: 'payment',
    loader: 'auto',
    amount: Math.round(tempAmount()),
    currency: 'usd',
    setup_future_usage: 'on_session',
    customerSessionClientSecret: clientSecretKey,
    payment_method_options: {
      card: { require_cvc_recollection: true }
    }
  };

  useEffect(() => {
    fetchCustomerSession();
  }, []);

  useEffect(() => {
    verifyApplePayAvailable();
  }, []);

  return (
    <div id="payment">
      <div id="payment-wrapper">
        <h1>Register & Payment</h1>
        <div className="row-first">
          <p>* All fields are required</p>
        </div>
        { clientSecretKey && (
          <Elements stripe={stripePromise} options={options}>
            <CheckoutForm cartState={cartState} handleRequest={handleRequest} />
          </Elements>
        )}
        { message && <div className="alert alert-danger">{message}</div> }
        <div className="row-last" />
      </div>
      {applePayAvailable && (
        <div id="payment-disclaimer">
          Apple Pay is a service provided by Apple Payments Services LLC, a
          subsidiary of Apple Inc. Use of Apple Pay is subject to the Apple
          Pay & Wallet terms and conditions located at <a href="https://www.apple.com/">www.apple.com</a>.
        </div>
      )}
    </div>
  );
}

PaymentElements.propTypes = {
  cartState: PropTypes.object,
  handleRequest: PropTypes.func,
};
